import { topics } from '@/mocks/home';

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-600">全网吃瓜群众正在热议的话题标签</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
          {topics.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className="group flex flex-col items-center gap-2 p-4 bg-background-50 rounded-xl hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 text-center whitespace-nowrap">{item.name}</span>
              <span className="flex items-center gap-1 text-xs">
                <span className="text-primary-600 font-medium">{item.heat}</span>
                <span className="text-foreground-500">热度</span>
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-line text-accent-600 text-xs"></i>
                ) : (
                  <i className="ri-arrow-down-line text-foreground-400 text-xs"></i>
                )}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}